import gql from "graphql-tag"

export const GET_BANK_DATA = gql`
    query getBankData($iban: String!) {
        getBankData(iban: $iban)
    }
`
